import { getHeaders } from './HttpUtil';
import AxiosClient from './AxiosClient';
import { getPageDetails } from '../store/Helpers/LandingHelper';

import type { IAuthorizationRequest, IMyConfigurationRequest } from '../../types/IApiTypes';

export const UserApi = {
  myConfigurations: async (payload: IMyConfigurationRequest) => {
    const { token, page, limit, searchKey, applicationIds, channelCodes, states } = payload;
    let parmas = { Page: page, Limit: limit };
    if (searchKey) {
      const search = { search: searchKey };
      parmas = { ...search, ...parmas };
    }
    try {
      const response = await AxiosClient.post(
        '/user/v1/configurations/read',
        {
          applicationIds: applicationIds ?? [],
          channels: channelCodes ?? [],
          states: states ?? [],
        },
        { params: parmas, headers: getHeaders(token)?.headers }
      );

      return {
        myConfigurations: response.data || [],
        pageDetails: getPageDetails(response, page, limit),
      };
    } catch {
      return null;
    }
  },

  getCategories: async (action: IAuthorizationRequest) => {
    try {
      const response = await AxiosClient.get(
        '/user/v1/configurations/filter/read',
        getHeaders(action.token)
      );
      return {
        category: response.data,
      };
    } catch {
      return null;
    }
  },
};
